import { render } from "./RemoveUsersFromMyRestaurant.vue?vue&type=template&id=d9efcd6c&scoped=true"
import script from "./RemoveUsersFromMyRestaurant.vue?vue&type=script&lang=js"
export * from "./RemoveUsersFromMyRestaurant.vue?vue&type=script&lang=js"

import "./RemoveUsersFromMyRestaurant.vue?vue&type=style&index=0&id=d9efcd6c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9efcd6c"]])

export default __exports__